/**
 * @generated SignedSource<<15d49d8f271b46f8be56ecc49931b155>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type SbRespRefineMenu_filters$data = ReadonlyArray<{
  readonly " $fragmentSpreads": FragmentRefs<"SbSharedRefineMenuDisplayPrefsSelect_filters" | "SbSharedRefineMenuFilters_filters">;
  readonly " $fragmentType": "SbRespRefineMenu_filters";
}>;
export type SbRespRefineMenu_filters$key = ReadonlyArray<{
  readonly " $data"?: SbRespRefineMenu_filters$data;
  readonly " $fragmentSpreads": FragmentRefs<"SbRespRefineMenu_filters">;
}>;

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": {
    "plural": true
  },
  "name": "SbRespRefineMenu_filters",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SbSharedRefineMenuFilters_filters"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SbSharedRefineMenuDisplayPrefsSelect_filters"
    }
  ],
  "type": "SearchBrowseFilter",
  "abstractKey": null
};

(node as any).hash = "fbe4a3afa9de14b2bf5167e3b6714133";

export default node;
